/**
 * Countdown for the promotion / announcement bar.
 * Moved out of the inline <script> so that tools that parse the theme HTML
 * (e.g. Blog Studio's editor) don't render the JS template strings as text.
 * Usage: <div class="countdown" data-date="2026-10-31T23:59:59"></div>
 */
(() => {
  if (window.__innoCountdownInit) return; // load once, even if included per block
  window.__innoCountdownInit = true;

  const digits = (number, length = 2) =>
    String(number)
      .padStart(length, '0')
      .split('')
      .map((d) => `<span class="digit">${d}</span>`)
      .join('');

  const group = (html) => `<div class="group">${html}</div>`;
  const separator = '<div class="separator">:</div>';

  function updateCountdowns() {
    document.querySelectorAll('.countdown').forEach((el) => {
      const dateString = el.dataset.date;
      if (!dateString) return;

      // "2026-08-05 15:37:25" is invalid in Safari -> use ISO "2026-08-05T15:37:25"
      const distance = new Date(dateString.trim().replace(' ', 'T')).getTime() - Date.now();
      if (Number.isNaN(distance)) return;

      if (distance < 0) {
        el.style.display = 'none';
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      el.innerHTML = [
        group(digits(days, 1)),
        group(digits(hours)),
        group(digits(minutes)),
        group(digits(seconds)),
      ].join(separator);
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000); // every second (was 9000 = every 9 s)
})();